<template>
  <div>


  <!-- Main container -->
<nav class="level">
  <!-- Left side -->
  <div class="level-left">
  <b-field class="level-item" label="Balance Sheet Percentage relative to:">
<b-select v-model="balancedivisor" placeholder="Common-Size" @input="loadTable">
<<option value="Common-Size" >Common-Size</option>
<<option value="Assets" >Assets</option>
<<option value="Liabilities">Liabilities</option>
<<option value="Equity">Equity</option>
<<option value="Sales">Sales</option>
<<option value="Cash">Cash</option>
<<option value="Profit">Operating Profit</option>
<<option value="GM">Gross Margin</option>

</b-select>
</b-field>

<b-field class="level-item" label="Income Statement Percentage relative to:">
<b-select v-model="incomedivisor"  placeholder="Common-Size" @input="loadTable">
<<option value="Common-Size" >Common-Size</option>
<<option value="Sales">Sales</option>
<<option value="Cash">Cash</option>
<<option value="Profit">Operating Profit</option>
<<option value="GM">Gross Margin</option>
<<option value="Assets" >Assets</option>
<<option value="Liabilities">Liabilities</option>
<<option value="Equity">Equity</option>


</b-select>
</b-field>

  </div>
</nav>


               <b-table :data="fslines" :striped="true">

                 <template slot-scope="props" slot="header">
                   <div style="color: red">{{ props.column.label }}</div>
                   <b-icon
                     v-if="props.column.meta"
                     pack="fas"
                     icon="info-circle"
                     size="is-small">
                   </b-icon>
                 </template>

                 <template slot-scope="props">
                   <template v-for="column in columns">
                     <b-table-column :field="column.field" :label="column.label" :numeric="column.numeric" :centered="column.centered" :meta="column.meta" :width="column.width">
                       {{props.row[column.field]}}
                     </b-table-column>
                   </template>

                 </template>

               </b-table>
               <div class="boxer">
                                    <div class="field is-grouped">
                                        <p class="control is-expanded">
                                        <button class="button is-primary" @click="downloadCSV">Download Excel (CSV)</button>

                                                                   </p>
                                    </div>
                                </div>

  </div>



</template>

<script>
import axios from 'axios'
import ModalBox from '@/components/ModalBox'
import { mapState , mapGetters} from "vuex";

export default {
  name: 'ClientsTableSample',
  components: { ModalBox },
  props: {
  fsparameters: {},
      dataUrl: {
      type: String,
      default: null
    },
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isModalActive: false,
      trashObject: null,
      incomedivisor: null,
      balancedivisor: null,
      clients: [],
      fslines: [],
      fsdata: [],
      isLoading: false,
      paginated: false,
      perPage: 10,
      columns: [
    {
        field: 'balancelabel',
        label: 'Balance Item',
    },
    {
        field: 'balancepercent',
        label: 'Pct(%)',
        width: 30,
    },
        {
        field: 'balancevalue',
        label: 'Dollars',
        width: 60,
    },
    {
        field: 'incomelabel',
        label: 'Income Item',
    },
    {
        field: 'incomepercent',
        label: 'Pct(%).',
        width: 30,
    },
        {
        field: 'incomevalue',
        label: 'Dollars ',
        width: 60,
    },
    {
        field: 'ratiolabel',
        label: 'Ratio',
    },
    {
        field: 'ratiovalue',
        label: 'Value',
        width: 60,
  }
    ],
    }
  },

  computed: {
  ...mapState({
  mapaxiosData: state => state.report.axiosData,
  status: state => state.report.status,
  })
  },
  watch: {
    status(thenew, theold) {
    console.log("status:",theold,thenew )

    if( thenew=="success") {
    this.loadAxiosData()
    }
    }
  },
  mounted () {
    // this.$store.commit(REPORT_RESTAPI, this.$api.REST_API)
    console.log("Mounted ClientsTableSample.vue",this.status)
    this.loadAxiosData()
  },
  methods: {

  loadAxiosData() {
  console.log("ClientsTableSample - mounted():")
  console.log(this.fsparameters)

  var axiosData = this.mapaxiosData

  console.log("axiosData")
  console.log(axiosData)


  if( this.incomedivisor  )
  {

  } else {
      this.incomedivisor = "Common-Size"
  }
  if( this.balancedivisor )
  {

  } else {
      this.balancedivisor = "Common-Size"
  }
    console.log( this.incomedivisor)
    console.log( this.balancedivisor)


//    this.sales = axiosData.sales
    this.$set(this.fsparameters, 'balance',axiosData.balance)
    this.$set(this.fsparameters, 'income',axiosData.income)
//      this.$set(this.fsparameters, 'sales',this.sales)
//  this.fslines.push ( { balancelabel: "Line Item", balancevalue: "Dollars",   incomelabel: 'Line Item', incomevalue: "Dollars", ratiolabel: 'Metric', ratiovalue: "Value"   })


  this.fsdata = []
  var div_balance = {common: axiosData.balance.totasset, sales: axiosData.sales, profit:  axiosData.income.profitx, gm: axiosData.income.gm, assets: axiosData.balance.totasset ,
  cash: this.fsparameters.balance.cash ,
    liabilities:  axiosData.balance.tdebt,  equity: axiosData.balance.networthequity }
    var div_income = {common: axiosData.sales, sales: axiosData.sales, profit:  axiosData.income.profitx, gm: axiosData.income.gm, assets: axiosData.balance.totasset ,
    cash: this.fsparameters.balance.cash ,
      liabilities:  axiosData.balance.tdebt,  equity: axiosData.balance.networthequity }

this.fsdata.push ( { balancelabel: "Cash", balancevalue: this.fsparameters.balance.cash ,
    divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
    incomelabel: "Sales", incomevalue:  axiosData.sales,
     ratiolabel: "Debt/Equity", ratiovalue: axiosData.ratios.debt2equity  })

     this.fsdata.push ( { balancelabel: "Net A/R", balancevalue: axiosData.balance.nar ,
     divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
         incomelabel: "Cost of Goods Sold", incomevalue:  axiosData.income.cogs,
          ratiolabel: "Return on Assets", ratiovalue: axiosData.ratios.returnonassets  })

          this.fsdata.push ( { balancelabel: "Inventory", balancevalue: axiosData.balance.inventory ,
          divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
              incomelabel: "Gross Margin", incomevalue:  axiosData.income.gm,
               ratiolabel: "Profit / CGS", ratiovalue: axiosData.ratios.profit2cgs  })

               this.fsdata.push ( { balancelabel: "Other Current Assets", balancevalue: axiosData.balance.othcur ,
               divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                   incomelabel: "Advertising", incomevalue:  axiosData.income.adv,
                    ratiolabel: "", ratiovalue: null   })

                    this.fsdata.push ( { balancelabel: "Current Assets", balancevalue: axiosData.balance.curasset ,
                    divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                        incomelabel: "Salaries & Wages", incomevalue:  axiosData.income.wages,
                        ratiolabel: "", ratiovalue: null   })

                   this.fsdata.push ( { balancelabel: "Long Term Investments", balancevalue: axiosData.balance.invest ,
                   divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                           incomelabel: "Employee Benefits", incomevalue:  axiosData.income.empben,
                           ratiolabel: "", ratiovalue: null   })

                  this.fsdata.push ( { balancelabel: "Plant, Property & Equipment", balancevalue: axiosData.balance.fixasset ,
                  divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                            incomelabel: "Pension & Annuity", incomevalue:  axiosData.income.pension,
                            ratiolabel: "", ratiovalue: null   })

                 this.fsdata.push ( { balancelabel: "Other Assets", balancevalue: axiosData.balance.othasset ,
                 divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                           incomelabel: "Officer Compensation", incomevalue:  axiosData.income.offcmp,
                           ratiolabel: "", ratiovalue: null   })

                this.fsdata.push ( { balancelabel: "Total Assets", balancevalue: axiosData.balance.totasset ,
                divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                          incomelabel: "Bad Debt", incomevalue:  axiosData.income.bdebt,
                          ratiolabel: "", ratiovalue: null   })


div_balance.common = div_balance.liabilities + div_balance.equity
this.fsdata.push ( { balancelabel: "Accounts Payable", balancevalue: axiosData.balance.ap ,
divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
incomelabel: "Rent Paid", incomevalue:  axiosData.income.rent,
ratiolabel: "", ratiovalue: null   })


this.fsdata.push ( { balancelabel: "Other Current Liabilities", balancevalue: axiosData.balance.othliab ,
divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
incomelabel: "Repairs", incomevalue:  axiosData.income.repair,
ratiolabel: "", ratiovalue: null   })

this.fsdata.push ( { balancelabel: "Total Current Liabilities", balancevalue: axiosData.balance.totalcurrentliab ,
divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
incomelabel: "Depreciation / Amort", incomevalue:  axiosData.income.deprec,
ratiolabel: "", ratiovalue: null   })


this.fsdata.push ( { balancelabel: "Long-Term Debt", balancevalue: axiosData.balance.ltliab ,
divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
incomelabel: "Interest Paid", incomevalue:  axiosData.income.interest,
ratiolabel: "", ratiovalue: null   })

this.fsdata.push ( { balancelabel: "Total Liabilities", balancevalue: axiosData.balance.tdebt ,
divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
incomelabel: "Misc Expenses", incomevalue:  axiosData.income.othded,
ratiolabel: "", ratiovalue: null   })

this.fsdata.push ( { balancelabel: "Net Worth / Equity", balancevalue: axiosData.balance.networthequity ,
divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
incomelabel: "Taxes Paid", incomevalue:  axiosData.income.taxpd,
ratiolabel: "", ratiovalue: null   })

this.fsdata.push ( { balancelabel: "", balancevalue: ''  ,
divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
incomelabel: "Operating Profit", incomevalue:  axiosData.income.profitx,
ratiolabel: "", ratiovalue: null   })

console.log(this.fsdata)
  var dp = this.loadTable()


  },

  loadTable() {
  this.fslines.length = 0
  this.fsdata.forEach((element, index, array) => {
//  console.log("********************ELEMENT*********************");
//  console.log(element);

      // make sure we adjust properly given the selected
      var i_divisor = 0.0
      var b_divisor = 0.0

      switch (this.balancedivisor ) {
        case "Common-Size":
            b_divisor = element.divisor_balance.common ;
            break;
            case "Sales":
                b_divisor = element.divisor_balance.sales ;
                break;
                case "Cash":
                    b_divisor = element.divisor_balance.cash ;
                    break;
                    case "Profit":
                        b_divisor = element.divisor_balance.profit ;
                        break;
                        case "GM":
                            b_divisor = element.divisor_balance.gm ;
                            break;
                            case "Assets":
                                b_divisor = element.divisor_balance.assets ;
                                break;
                                case "Liabilities":
                                    b_divisor = element.divisor_balance.liabilities ;
                                    break;
                                    case "Equity":
                                        b_divisor = element.divisor_balance.equity ;
                                        break;

      }
      switch (this.incomedivisor ) {
        case "Common-Size":
            i_divisor = element.divisor_income.common ;
            break;
            case "Sales":
                i_divisor = element.divisor_income.sales ;
                break;
                case "Cash":
                    i_divisor = element.divisor_income.cash ;
                    break;
                    case "Profit":
                        i_divisor = element.divisor_income.profit ;
                        break;
                        case "GM":
                            i_divisor = element.divisor_income.gm ;
                            break;
                            case "Assets":
                                i_divisor = element.divisor_income.assets ;
                                break;
                                case "Liabilities":
                                    i_divisor = element.divisor_income.liabilities ;
                                    break;
                                    case "Equity":
                                        i_divisor = element.divisor_income.equity ;
                                        break;

      }

      var rvalue = null
      var bvalue = null
      var ivalue = null
      var bpct = null
      var ipct = null
      if( element.ratiolabel != "") {
        rvalue = element.ratiovalue.toFixed(2)
      }

      if( element.balancelabel != "") {

        bvalue = "$"  + element.balancevalue.toFixed(1)
        if( b_divisor != 0 ) {
            bpct = ((element.balancevalue / b_divisor)*100).toFixed(1) + "%"
        }
      }
      if( element.incomelabel != "") {

        ivalue = "$" + element.incomevalue.toFixed(1)
        if( i_divisor != 0 ) {
            ipct = ((element.incomevalue / i_divisor)*100).toFixed(1) + "%"
        }
      }



            var myrow = { balancelabel: element.balancelabel, balancepercent: bpct, balancevalue: bvalue,
      incomelabel: element.incomelabel,    incomepercent: ipct , incomevalue: ivalue,
      ratiolabel: element.ratiolabel, ratiovalue: rvalue         }
  //    console.log("********************myrow*********************");

      if( true) {
      this.fslines.push(myrow)
      }
  //    console.log(myrow);
      // console.log(array); // same myArray object 3 times

  });

    this.fslines = this.fslines.slice(0)
  },

  downloadCSV() {

  var URI = this.$api.REST_API + '/Reports/NormCSV'

  axios
    .post(URI, {naics: "238110", range: "03", state: "", zip: "" })
    .then(r => {
    console.log(r)
    var fileURL = window.URL.createObjectURL(new Blob([axiosData]));
var fileLink = document.createElement('a');

fileLink.href = fileURL;
fileLink.setAttribute('download', 'file.csv');
document.body.appendChild(fileLink);

fileLink.click();
    })
    .catch(e => {
    })
  },
    trashModal (trashObject) {
      this.trashObject = trashObject
      this.isModalActive = true
    },
    trashConfirm () {
      this.isModalActive = false
      this.$buefy.snackbar.open({
        message: 'Confirmed',
        queue: false
      })
    },
    trashCancel () {
      this.isModalActive = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ClientsTableSample.vue